/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC725Y, ERC725YInterface } from "../ERC725Y";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "key",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "value",
        type: "bytes",
      },
    ],
    name: "DataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keys",
        type: "bytes32[]",
      },
    ],
    name: "getData",
    outputs: [
      {
        internalType: "bytes[]",
        name: "values",
        type: "bytes[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "_keys",
        type: "bytes32[]",
      },
      {
        internalType: "bytes[]",
        name: "_values",
        type: "bytes[]",
      },
    ],
    name: "setData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ERC725Y__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _newOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC725Y> {
    return super.deploy(_newOwner, overrides || {}) as Promise<ERC725Y>;
  }
  getDeployTransaction(
    _newOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_newOwner, overrides || {});
  }
  attach(address: string): ERC725Y {
    return super.attach(address) as ERC725Y;
  }
  connect(signer: Signer): ERC725Y__factory {
    return super.connect(signer) as ERC725Y__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC725YInterface {
    return new utils.Interface(_abi) as ERC725YInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC725Y {
    return new Contract(address, _abi, signerOrProvider) as ERC725Y;
  }
}
